import { ApiResponse, TokenData, Department } from "../models";
import * as http from "./http";
import ApiService from "./service";

export class DepartmentService extends ApiService {
  public async loadAllDepartments() {
    const url = `${this.apiDomain}/api/department`;
    const resposne = await http.get<ApiResponse<Department[]>>(url, this.store);
    return resposne?.data?.data;
  }

  public async updateDepartment(data: Department, id?: string) {
    const url = `${this.apiDomain}/api/department/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(url, data, this.store);
    return response.data;
  }

  public async createDepartment(data: Department) {
    const url = `${this.apiDomain}/api/department`;

    const response = await http.post<ApiResponse<TokenData>>(url, data, this.store);
    return response.data;
  }

  public async deleteDepartment(id?: string) {
    const url = `${this.apiDomain}/api/department/${id}`;

    const response = await http.remove<ApiResponse<Department>>(url, this.store);
    return response.data;
  }
}
